import moment from 'moment';
import Swal from 'sweetalert2';
const utility = {
    readFile: (event, data, key) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            // data[key] = reader.result;
            data(reader.result);
            // console.log(pd);
        };
    },
    formatDateTime: (dt) => {
        if (!dt) return "";
        const date = new Date(dt);
        const formattedDate = moment(date).format('YYYY-MM-DD hh:mm A');
        console.log(formattedDate)
        return formattedDate;
    },
    formatDate: (dt) => {
        if (!dt) return "";
        const date = new Date(dt);
        const formattedDate = moment(date).format('YYYY-MM-DD');
        console.log(formattedDate)
        return formattedDate;
    },
    formatDateDMY: (dt) => {
        if (!dt) return "";
        const date = new Date(dt);
        return moment(date).format('DD-MM-YYYY');
    },
    formatTime: (dt) => {
        if (!dt) return "";
        const date = new Date(dt);
        const formattedDate = moment(date).format('HH:MM');
        console.log(formattedDate)
        return formattedDate;
    },
    convertDate(date) {
        var event = new Date(date);
        let date1 = JSON.stringify(event);
        date = date1.slice(1, 11);
        return date;
    },
    hasPermission: (permission, action) => {
        return Number(permission?.[action]) === 1;
    },
    checkViewPermission: (permission, showMessage, navigate) => {
        if (permission?.canView != 1) {
            utility.showError("You do not have permission");
            navigate('/cpnl/unauthorized');
            return false;
        }
        return true;
    },

    // Toast Notification configuration
    toast: Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    }),

    showSuccess: (message) => {
        utility.toast.fire({
            icon: 'success',
            title: message
        });
    },

    showError: (message) => {
        utility.toast.fire({
            icon: 'error',
            title: message || 'Something went wrong!'
        });
    }


}

export default utility;